// extracted by mini-css-extract-plugin
export default {"container":"styles_container__PUNZk","celebrate":"styles_celebrate__X3Fp+","title":"styles_title__UYF5s"};